import { render, staticRenderFns } from "./IconNumberBall.vue?vue&type=template&id=37f2a0ce&"
import script from "./IconNumberBall.vue?vue&type=script&lang=js&"
export * from "./IconNumberBall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports